<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="批量设置账户运营负责人"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="运营负责人：" prop="user_id">
                <ESelect v-model="formItem.user_id" clearable filterable placeholder="请选择">
                    <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </ESelect>
            </el-form-item>
            <el-form-item label="负责开始时间：" prop="operation_time">
                <el-date-picker
                    v-model="formItem.operation_time"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" 
            v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '批量设置运营(取消)' }"
            @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" 
            v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '批量设置运营(提交)' }"
            @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
        <ResultModal ref="resultModal" :code="resultCode" :info="resultInfo" :res-data="resultData" @cover="coverSubmit" @close="handleClose"/>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';
    import ResultModal from './batchYYResult';
    import utils from '@/libs/utils';

    export default {
        name: "BatchYYModal",
        components: {
            ResultModal,
        },
        props: {
            accountList: {
                required: true,
                type: Array,
            }
        },
        data() {
            return {
                submitLoading: false,
                dialogVisible: false,
                formItem: {
                    user_id: '',
                    operation_time: new Date(),
                },
                rules: {
                    user_id: [
                        {required: true, message: '请选择运营负责人', trigger: 'blur'},
                    ],
                    operation_time: [
                        {required: true, message: '请选择负责开始时间', trigger: 'blur'},
                    ],
                },
                userList: [],
                pickerOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                resultCode: '',
                resultInfo: '',
                resultData: {
                    same_time: [],
                    same_user_time: [],
                    err_num: 0,
                    succ_num: 0,
                },
            }
        },
        computed: {},
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
                this.getUserList();

                this.$nextTick(() => {

                })
            },
            resetForm() {
                this.submitLoading = false;
                this.$refs['form'].resetFields();
                this.resultCode = '';
                this.resultInfo = '';
                this.resultData.same_time = [];
                this.resultData.same_user_time = [];
                this.resultData.err_num = 0;
                this.resultData.succ_num = 0;
            },
            getUserList() {
                API.getYYUserList().then(res => {
                    this.userList = res.data || [];
                }, (err) => {
                    console.log('getYYUserList error', err);
                    this.userList = [];
                });
            },
            coverSubmit(){
                let companyData = this.resultData.same_time.map(item => (item.plat_id + '-' + item.company_id));
                let data = {
                    user_id: this.formItem.user_id,
                    operation_time: utils.formatDate(this.formItem.operation_time,'YYYYMMDD'),
                    plat_company: companyData,
                    cover: '1',
                };
                API.setYY(data).then(res => {
                    // this.$message.success(res.info || '操作成功');
                    this.resetForm();
                    this.dialogVisible = false;
                    this.$emit('update');
                    this.hideResultModal();

                    let result = res.data || {};
                    this.resultCode = res.code;
                    this.resultInfo = res.info;
                    this.resultData.same_time = result.same_time || [];
                    this.resultData.same_user_time = result.same_user_time || [];
                    this.resultData.err_num = result.err_num || 0;
                    this.resultData.succ_num = result.succ_num || 0;
                    this.showResultModal();
                    this.submitLoading = false;
                }, (err) => {
                    console.log('setYY batch error', err);
                    this.submitLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length==0){
                        this.$message.error(err.info || '操作失败');
                        this.$refs.resultModal.endLoading();
                    }else{
                        this.hideResultModal();
                        let result = err.data || {};
                        this.resultCode = err.code;
                        this.resultInfo = err.info;
                        this.resultData.same_time = result.same_time || [];
                        this.resultData.same_user_time = result.same_user_time || [];
                        this.resultData.err_num = result.err_num || 0;
                        this.resultData.succ_num = result.succ_num || 0;
                        this.showResultModal();
                        this.resetForm();
                        this.dialogVisible = false;
                    }
                });
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let companyData = this.accountList.map(item => (item.plat_id + '-' + item.company_id));

                        let data = {
                            user_id: this.formItem.user_id,
                            operation_time: utils.formatDate(this.formItem.operation_time,'YYYYMMDD'),
                            plat_company: companyData,
                            cover: '0',
                        };

                        this.submitLoading = true;
                        API.setYY(data).then(res => {
                            // this.$message.success(res.info || '操作成功');
                            this.$emit('update');
                            this.hideResultModal();

                            let result = res.data || {};
                            this.resultCode = res.code;
                            this.resultInfo = res.info
                            this.resultData.same_time = result.same_time || [];
                            this.resultData.same_user_time = result.same_user_time || [];
                            this.resultData.err_num = result.err_num || 0;
                            this.resultData.succ_num = result.succ_num || 0;
                            this.showResultModal();
                            this.submitLoading = false;
                        }, (err) => {
                            console.log('setYY batch error', err);
                            this.hideResultModal();

                            let errData = err.data||[];

                            if(err.code==0&&errData.length==0){
                                this.$message.error(err.info || '操作失败');
                            }else{
                                let result = err.data || {};
                                this.resultCode = err.code;
                                this.resultInfo = err.info;
                                this.resultData.same_time = result.same_time || [];
                                this.resultData.same_user_time = result.same_user_time || [];
                                this.resultData.err_num = result.err_num || 0;
                                this.resultData.succ_num = result.succ_num || 0;
                                this.showResultModal();
                            }

                            this.submitLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            showResultModal() {
                this.$refs.resultModal.showModal();
            },
            hideResultModal(){
                this.$refs.resultModal.hideModal();
            }
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }
</style>
